import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';

export const MenuWrapper = styled.div`
  z-index: 20;
  min-width: 350px;
  position: absolute;
  top: calc(100% + 8px);
  background: ${({ theme }) => theme.colors.neutrals.white};
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.06), 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  padding-top: ${({ theme }) => theme.spacing(4)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    right: 0;
  `}
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    left: 0;
  `}
`;

export const MobileMenuWrapper = styled.div`
  z-index: 1;
  min-width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.neutrals.white};
  padding-top: ${({ theme }) => theme.spacing(4)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const ActionWrapper = styled(Text)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(3)}`};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.neutrals.grey10};
  }
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.neutrals.grey8};
  margin: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(4)}`};
`;

export const UserInfo = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(3)} ${theme.spacing(2)}`};
  gap: ${({ theme }) => theme.spacing(1.25)};
  display: flex;
  align-items: center;
`;

export const UserEmailName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
`;
export const Email = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey3};
`;

export const Counter = styled(Text)`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.neutrals.grey9};
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin-right: auto;
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.borderRadius.round};
`;
